// extracted by mini-css-extract-plugin
export default {"attributesContainer":"Attributes_attributesContainer__Keyxz","backButton":"Attributes_backButton__HuHfa"};